import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import ButtonView from "@ckeditor/ckeditor5-ui/src/button/buttonview";
import Command from "@ckeditor/ckeditor5-core/src/command";

// 1. Define the Video Command
class VideoUploadCommand extends Command {
  refresh() {
    // Automatically disables the button if any multimedia has been uploaded
    const IsUploaded = this.editor.config.get("isMultimediaUploaded");
    this.isEnabled = !IsUploaded;
    // this.isEnabled = !this.value;
  }

  // execute(assetId: string) {
  //   const editor = this.editor;
  //   const videoUrl = `${import.meta.env.VITE_STRAPI_ASSET_VIDEO_URL}/${assetId}`;

  //   editor.model.change((writer) => {
  //     const viewFragment = editor.data.processor.toView(
  //       `<video controls width="100%" src="${videoUrl}"></video>`
  //     );
  //     const modelFragment = editor.data.toModel(viewFragment);
  //     editor.model.insertContent(
  //       modelFragment,
  //       editor.model.document.selection
  //     );
  //   });
  // }
}

export default class VideoUploadPlugin extends Plugin {
  uploadFn: any;

  constructor(editor: any) {
    super(editor);
    this.uploadFn = editor.config.get("videoUploadFn");
  }

  init() {
    const editor = this.editor;
    editor.commands.add("videoUpload", new VideoUploadCommand(editor));

    editor.ui.componentFactory.add("videoUpload", (locale) => {
      const button = new ButtonView(locale);
      const command = editor.commands.get("videoUpload")!;

      button.set({
        label: "Insert Video",
        tooltip: true,
        withText: false,
        icon: `
<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path d="M3 5h10a2 2 0 0 1 2 2v1l3-2v8l-3-2v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z"/>
</svg>
`
      });

      button.bind("isEnabled").to(command);

      button.on("execute", () => {
        this._openFileDialog(editor);
      });

      return button;
    });
  }

  async _openFileDialog(editor: any) {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "video/*";

    input.onchange = async () => {
      const file = input.files?.[0];
      if (!file) return;

      if (!file.type.startsWith("video/")) {
        alert("Only video files allowed");
        return;
      }

      try {
        const assetId = await editor.config.get("videoUploadFn")(file);
        if (assetId) {
          // editor.config.set("isMultimediaUploaded", false);
          editor.execute("videoUpload", assetId);
          editor.model.change((writer: any) => {
            const viewFragment = editor.data.processor.toView(
              `<video controls width="100%" src="${import.meta.env.VITE_STRAPI_ASSET_VIDEO_URL}/${assetId}"></video>`
            );

            const modelFragment = editor.data.toModel(viewFragment);

            editor.model.insertContent(
              modelFragment,
              editor.model.document.selection
            );
          });
        }
      } catch (error) {
        console.error("Video upload failed:", error);
        alert("Video upload failed");
      }
    };

    input.click();
  }
}
